import { size } from 'lodash'

export const dateToFullString = (stringDate = '') => {
  if (stringDate) {
    const currentDate = new Date(Date.parse(stringDate))

    const min =
      size(`${currentDate.getUTCMinutes()}`) < 2
        ? `0${currentDate.getUTCMinutes()}`
        : currentDate.getUTCMinutes()
    const hour = currentDate.getUTCHours()
    const day =
      currentDate.getUTCDate() < 10 ? `0${currentDate.getUTCDate()}` : `${currentDate.getUTCDate()}`
    const months = [
      'Ene.',
      'Feb.',
      'Mar.',
      'Abr.',
      'May.',
      'Jun.',
      'Jul.',
      'Aug.',
      'Sep.',
      'Oct.',
      'Nov.',
      'Dic.',
    ]
    const month = months[currentDate.getUTCMonth()]
    const year = currentDate.getUTCFullYear()

    const dateString = `${day} ${month} ${year} - ${hour}:${min}h`

    return dateString
  }

  return '-'
}

export const dateToString = (date = '') => {
  if (date) {
    const currentDate = new Date(Date.parse(date))

    const day =
      currentDate.getUTCDate() < 10 ? `0${currentDate.getUTCDate()}` : `${currentDate.getUTCDate()}`
    const month =
      currentDate.getUTCMonth() < 10
        ? `0${currentDate.getUTCMonth() + 1}`
        : `${currentDate.getUTCMonth() + 1}`
    const year = currentDate.getUTCFullYear()

    const dateString = `${day}-${month}-${year}`

    return dateString
  }

  return ''
}
